/** Mirrors Prisma `AnnouncementStatus`. */
export enum AnnouncementStatus {
  Draft = "DRAFT",
  Active = "ACTIVE",
  Paused = "PAUSED",
  Expired = "EXPIRED",
}

/** Mirrors Prisma `AnnouncementSeverity`. Drives ordering + visual treatment. */
export enum AnnouncementSeverity {
  Info = "INFO",
  Success = "SUCCESS",
  Warning = "WARNING",
  Critical = "CRITICAL",
}

/** Mirrors Prisma `AnnouncementDismissBehavior`. */
export enum AnnouncementDismissBehavior {
  /** User cannot dismiss. Reserved for critical messages. */
  NotDismissible = "NOT_DISMISSIBLE",
  /** Once dismissed, never returns for this user. */
  DismissForever = "DISMISS_FOREVER",
  /** Returns when the announcement's version increments past the dismissed version. */
  DismissUntilUpdated = "DISMISS_UNTIL_UPDATED",
  /** Returns after `snoozedUntil` elapses (defaults to `remindLaterMinutes`). */
  RemindLater = "REMIND_LATER",
}

/** Mirrors Prisma `AnnouncementTargetType`. */
export enum AnnouncementTargetType {
  /** Everyone — no target rows needed but a PLATFORM row may be stored. */
  Platform = "PLATFORM",
  /** All members of a specific workspace. */
  Workspace = "WORKSPACE",
  /** Members of a specific workspace + branch combination. */
  WorkspaceBranch = "WORKSPACE_BRANCH",
  /** Specific users by id. */
  Users = "USERS",
  /** All users with a system-admin role (admin dashboard audience). */
  SystemUsers = "SYSTEM_USERS",
}

/** Mirrors Prisma `AnnouncementActionType`. */
export enum AnnouncementActionType {
  None = "NONE",
  /** App-internal route. `actionTarget` is a path like `/w/<slug>/...`. */
  InternalRoute = "INTERNAL_ROUTE",
  /** Full URL (must be https + allowlisted). */
  ExternalUrl = "EXTERNAL_URL",
  /** Opaque key resolved by backend at click time. v1 records intent only. */
  BackendResolved = "BACKEND_RESOLVED",
}

/** Mirrors Prisma `AnnouncementSource`. */
export enum AnnouncementSource {
  Manual = "MANUAL",
  System = "SYSTEM",
  Automation = "AUTOMATION",
}

/** Mirrors Prisma `AnnouncementPlacement`. Which surface renders the announcement. */
export enum AnnouncementPlacement {
  /** The thin banner above the tenant header (default, original surface). */
  HeaderBanner = "HEADER_BANNER",
  /** A dismissible promo card in the sidebar footer. */
  SidebarPromo = "SIDEBAR_PROMO",
}
